import React from 'react';

/**
 * A count with a proportional bar behind it.
 *
 * Extracted from AnalyticsPage.js when InsightsPage became a second caller.
 * Built from the existing :root tokens rather than a chart library -- the rule
 * global.css states and AnalyticsPage.js has followed since issue #62: one more
 * dependency for a handful of bar lists is not a trade worth making, and
 * global.css is the app's only stylesheet.
 *
 * `max` is the largest count in the SAME list, so each list is scaled to itself.
 * A shared scale would flatten a short list against a far larger one -- which is
 * exactly what would happen to the filter list beside the search list.
 */
function CountBar({ value, max, tone = 'var(--teal-500)', suffix = null }) {
  const pct = max > 0 ? Math.max(2, Math.round((value / max) * 100)) : 0;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <div style={{
        flex: 1, height: '8px', borderRadius: 'var(--radius-pill)',
        background: 'var(--surface-alt)', overflow: 'hidden', minWidth: '60px',
      }}>
        <div style={{ width: `${pct}%`, height: '100%', background: tone }} />
      </div>
      <span style={{ minWidth: '38px', textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>
        {suffix === null ? value : suffix}
      </span>
    </div>
  );
}

export default CountBar;
